import { useRouter } from 'next/router';

import { useInitLikedProducts, useLikeProductService, WebLikeProductPayload } from '@widgets/like-product';
import { appendMessageQueryFromPath } from '@widgets/messenger';
import { useGetReviewEventBannerByProductIdQuery } from '@widgets/review-event-banner';
import {
  TabType,
  useCatalogProductIdParams,
  usePdpBaseInfo,
  usePdpConfig,
  useProductPreviewAtiveTabType,
  useProductReviewTotalCount,
} from '@domains/pdp-common';

import { useSubButtonLog } from '../log/useSubButtonLog';
import { useLoginQuery } from '../query/useSavedProductIdListQuery';

export function useSubButtonService({ product_id, shop_id }: { product_id: string; shop_id: string }) {
  const params = useCatalogProductIdParams();
  const { push } = useRouter();
  const { path, isGlobal, isProductPreview } = usePdpConfig();
  const [_, setProductPreviewActiveTabType] = useProductPreviewAtiveTabType();
  const log = useSubButtonLog();
  const { review_total_count } = useProductReviewTotalCount(product_id);
  const { data } = useGetReviewEventBannerByProductIdQuery({ catalogProductId: product_id });
  const { product } = usePdpBaseInfo(params);
  const loginQuery = useLoginQuery();

  const { onWebLikeProduct } = useLikeProductService(isProductPreview ? { webToastStyle: { bottom: '107px' } } : {});

  useInitLikedProducts({
    data: [
      {
        catalog_product_id: product_id,
        is_saved_product: product.is_saved_product,
      },
    ],
    convert: (data) => data.map((value) => value.catalog_product_id),
  });

  const likeProduct = (isLiked: boolean) => {
    const webLikeProductPayload: WebLikeProductPayload = {
      checked: !isLiked,
      productData: { catalog_product_id: product_id, shop_id },
      airbridge: log.getWisthListAirbridge(),
      sendLog: (checked) => log.likeProductUBL(checked, { catalog_product_id: product_id }),
    };

    onWebLikeProduct(webLikeProductPayload);
  };

  return {
    has_review_event: Boolean(data?.simple_banner?.id),
    review_total_count,
    is_visible: !isGlobal,
    is_disable_click: loginQuery.isLoading,
    is_login: loginQuery.data,
    likeProduct: (isLiked: boolean) => likeProduct(isLiked),
    goToReviewList: () => {
      if (isProductPreview) {
        setProductPreviewActiveTabType(TabType.REVIEW);
      } else {
        push(path.review.list(product_id));
      }
    },
    goToLogin: () => {
      push(
        appendMessageQueryFromPath(
          `${path.auth.login}?redirect=${window.location.origin + window.location.pathname}`,
          'availablePostLogin',
        ),
      );
    },
  };
}
